import BigWithSmallElementRow from './BigWithSmallElementRow';

export default BigWithSmallElementRow;
